module.exports = __webpack_public_path__ + "media/images/covers/foundation/our-teachers-01-36e14bb5184829d8170b64bec3252c02.jpg";